// i18n
import './locales/i18n';

// highlight
import './utils/highlight';

// scroll bar
import 'simplebar/src/simplebar.css';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

import ReactDOM from 'react-dom';
import { SWRConfig } from 'swr';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { EventsProvider } from './contexts/events';
import { LeaguesProvider } from './contexts/leagues';
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';

import { AuthProvider } from './contexts/Auth0Context';

import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import './utils/styles.css';

// ----------------------------------------------------------------------

ReactDOM.render(
  <BrowserRouter>
    <AuthProvider>
      <HelmetProvider>
        <EventsProvider>
          <LeaguesProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <SWRConfig value={{ provider: () => new Map() }}>
                <SettingsProvider>
                  <CollapseDrawerProvider>
                    <App />
                  </CollapseDrawerProvider>
                </SettingsProvider>
              </SWRConfig>
            </LocalizationProvider>
          </LeaguesProvider>
        </EventsProvider>
      </HelmetProvider>
    </AuthProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
